import React from 'react'

function Error() {
    return (
        <div className='NotFoundPage'>
            <h1 className="">404</h1>
            <p>Page too rare, not found</p>
        </div>
    )
}

export default Error
